import { FC } from 'react'
import Swal from 'sweetalert2'
import { IconPaths, showAlertLoading, showError } from '../../../../../../../_metronic/helpers'
import { AtendimentoList } from '../../../../atendimento/core/_models'
import { RowActions } from '../../../../../../components'
import { baixarAso } from '../../core/_request'

type Props = {
  atendimento: AtendimentoList
}

/** Ação única da linha: baixar o PDF do ASO (gera antes, se ainda não foi gerado). */
const AtendimentoAsoDownloadCell: FC<Props> = ({ atendimento }) => {
  const nome = `ASO ${atendimento.protocolo ?? ''}`.trim()

  const handleDownload = async () => {
    try {
      showAlertLoading()
      await baixarAso(atendimento)
      Swal.close()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: 'Baixar', onClick: handleDownload, icon: IconPaths.Download }}
    />
  )
}

export { AtendimentoAsoDownloadCell }
